module.exports = __webpack_public_path__ + "static/media/Ex1-S4.140cc616.PNG";